import { graphql } from "react-apollo";
import { updateNode } from './queries';
import SaveButton from '../../components/SaveButton';

export default graphql(updateNode, { options: { refetchQueries: ['Contents'] } })(SaveButton)
